import { createSlice, createSelector, PayloadAction } from "@reduxjs/toolkit";
import { UserData } from "model/auth-model";
import { useSelector } from "react-redux";

// export interface UserData {
//   token: string;
//   refreshToken: string;
// }

export interface AuthState {
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
  user: any | null;
}

const initialState: AuthState = {
  isAuthenticated: Boolean(localStorage.getItem("userData")),
  loading: false,
  error: null,
  user: retrieveUserData(),
};


export function retrieveUserData(): UserData | null {
  const userDataString = localStorage.getItem("userData");
  try {
    return userDataString ? JSON.parse(userDataString) : null;
  } catch (error) {
    console.error("Error parsing user data:", error);
    return null;
  }
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userLogin: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
      if (action.payload) {
        localStorage.setItem('userData', JSON.stringify(state.user));
        state.isAuthenticated = true;
      }
    },
    
    storeRefreshData: (state, action: PayloadAction<Partial<UserData>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
        localStorage.setItem('userData', JSON.stringify(state.user));
      }
    },
    logout: (state) => {
      state.isAuthenticated = false;
      localStorage.clear();
      state.user = null;
    },
  },
});

// Selector to retrieve the complete user data object
export const getUserData = (state: { auth: AuthState }) => state.auth.user;

// Selectors for specific user data properties
// export const getUserName = createSelector(
//   getUserData,
//   (userData) => (userData?.firstName || '', userData?.lastName || '')
// );

// export const getUserEmail = createSelector(
//   getUserData,
//   (userData) => userData?.email || ''
// );

// export const getUserPhoneNumber = createSelector(
//   getUserData,
//   (userData) => userData?.phoneNumber || ''
// );

// export const getUserRole = createSelector(
//   getUserData,
//   (userData) => userData?.roles || []
// );

// export const getUserId = createSelector(
//   getUserData,
//   (userData) => userData?.userId || ''
// );

export const getToken = createSelector(
  getUserData,
  (userData) => userData?.token || ''
);


export const { userLogin, storeRefreshData, logout } = authSlice.actions;
export const selectIsAuthenticated = (state: { auth: AuthState }) => state.auth.isAuthenticated;

export default authSlice.reducer;
